import getPageTemplates from './page-templates';

const getPageTemplate = (rootState, pageTemplateId) =>
  getPageTemplates(rootState).find((pageTemplate) => pageTemplate.id === pageTemplateId) || null;

export default getPageTemplate;
